import { useRef, useState } from "react"
import EmpButton, { EmpButtonRef } from "../../../components/shared/emp-button/emp-button"
import EmpCheckboxGroup from "../../../components/shared/emp-checkbox-group/emp-checkbox-group"
import EmpSelect from "../../../components/shared/emp-select/emp-select"
import EmpTextInput from "../../../components/shared/emp-text-input/emp-text-input"
import { countriesOptions, numEmployeesOptions } from "../../../constants/selectConstants"
import { empDelay } from "../../../utilities/delay"
import { FormControl } from "../../../utilities/formUtils/formControl"
import { FormGroupUtil, IFormGroup } from "../../../utilities/formUtils/formGroup"
import { RequiredValidator } from "../../../utilities/formUtils/requiredValidator"

interface Props { }
const EnterpriseFormView = (props: Props) => {

    const submitButtonRef = useRef<EmpButtonRef>();

    const enterpriseForm: IFormGroup = {
        fullName: new FormControl("text", [new RequiredValidator("Full name is required")], ""),
        companyName: new FormControl("text", [new RequiredValidator("Company name is required")], ""),
        email: new FormControl("text", [new RequiredValidator("Email is required")], ""),
        website: new FormControl("text", [], ""),
        country: new FormControl("text", [new RequiredValidator("Please select yoru country")], ""),
        numEmployees: new FormControl("text", [new RequiredValidator("Please select the number of employees")], ""),
        interests: new FormControl("checkbox-group", [new RequiredValidator("Please select at lease one interest")], ""),
        remarks: new FormControl("text", [], "")
    }

    const [form, setForm] = useState<IFormGroup>(enterpriseForm);
    const hasSubmitted = useRef(false);

    const onSubmit = async () => {
        hasSubmitted.current = true;

        const isValid = FormGroupUtil.validate(form)
        console.log(form)
        setForm({ ...form })

        // if (!isValid) return

        if (submitButtonRef.current) {
            submitButtonRef.current.setButtonState("loading")
        }
        await empDelay(4000)
        if (submitButtonRef.current) {
            submitButtonRef.current.setButtonState("default")
        }

    }

    const validate = (formControl: FormControl): void => {
        console.log("validate", hasSubmitted.current)
        if (!hasSubmitted.current) return;
        if (formControl.validateTrackDiff()) {
            setForm({ ...form })
        }
    }


    return <div className="enterprise-form-section">
        <h2>Enterprise Interest Form</h2>

        <div className="form-row mt-4">
            <div className="left-group">
                <EmpTextInput
                    id={"full-name"}
                    placeholder={"Jane Smith"}
                    labelText="Full Name"
                    formControl={form.fullName}
                    onChange={(formControl) => validate(formControl)}
                    required
                />
            </div>
            <div className="right-group">
                <EmpTextInput
                    id={"company-name"}
                    placeholder={"Example Company Pte Ltd"}
                    labelText="Company Name"
                    formControl={form.companyName}
                    onChange={(formControl) => validate(formControl)}
                    required
                />
            </div>
        </div>

        <div className="form-row">
            <div className="left-group">
                <EmpTextInput
                    id={"email"}
                    placeholder={"jane@example.com"}
                    labelText="Email"
                    formControl={form.email}
                    onChange={(formControl) => validate(formControl)}
                    required />
            </div>
            <div className="right-group">
                <EmpTextInput
                    id={"website"}
                    placeholder={"example.com"}
                    labelText="Company Website"
                    formControl={form.website}
                />
            </div>
        </div>

        <div className="form-row">
            <div className="left-group">
                <EmpSelect
                    id={"country"}
                    required
                    placeholder={"Select Country"}
                    labelText="Country"
                    selectOptions={countriesOptions}
                    onChange={(formControl) => validate(formControl)}
                    formControl={form.country} />
            </div>
            <div className="right-group">
                <EmpSelect
                    id={"country"}
                    required
                    placeholder={"Number of employees"}
                    labelText="Number of employees"
                    selectOptions={numEmployeesOptions}
                    onChange={(formControl) => validate(formControl)}
                    formControl={form.numEmployees} />
            </div>
        </div>

        <EmpCheckboxGroup
            id={"interests"}
            required
            labelText="Interests"
            formControl={form.interests}
            onChange={(formControl) => validate(formControl)}
            description="How would you describe your business or area of interest? Select all that apply."
            checkboxOptions={[{
                label: "Blasting posts across different platforms",
                value: "manage-social-media"
            },
            {
                label: "Analyzing social media campaigns performance",
                value: "campaign-metrics"
            },
            {
                label: "Collaborating with our Talent Agencies for Influencer marketing",
                value: "influencer-marketing"
            }
            ]} />

        <EmpTextInput
            id={"remarks"}
            placeholder={"Any other needs"}
            labelText="Anything else?"
            multiline
            formControl={form.remarks} />

        <div className="button-section">
            <div className="button-wrapper">
                <EmpButton
                    ref={submitButtonRef}
                    onSubmit={() => { onSubmit() }}
                    text={"Submit"} />
            </div>
        </div>

    </div>
}
export default EnterpriseFormView